import React from "react";
import PropTypes from "prop-types";
import {
  getIdentityFields,
  getContactFields,
  getAddressFields,
  getBankingFields,
  getEffectiveValue,
} from "./fieldConfig";

const shown = (value) =>
  value ? value : <span style={{ color: "var(--vz-secondary-color, #767683)" }}>Not set</span>;

const sectionHeader = (title, onEdit) => (
  <div
    className="d-flex align-items-center"
    style={{
      padding: "11px 14px",
      background: "var(--vz-light)",
      borderBottom: "1px solid var(--vz-border-color)",
    }}
  >
    <span
      className="text-uppercase text-muted flex-grow-1"
      style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.7 }}
    >
      {title}
    </span>
    <button type="button" className="btn btn-sm btn-outline-primary" onClick={onEdit}>
      Edit
    </button>
  </div>
);

const rowLabel = (text) => (
  <div className="text-uppercase text-muted" style={{ fontSize: 10.5, fontWeight: 600, letterSpacing: 0.5 }}>
    {text}
  </div>
);

const rowValue = (value) => (
  <div style={{ fontSize: 13.5, fontWeight: 500, marginTop: 3, overflowWrap: "anywhere" }}>{shown(value)}</div>
);

// Final wizard step — read-only summary of every section with an Edit
// button that jumps straight back to it, matching the mockup's Review step.
const ReviewStep = ({ validation, isNaturalClient, onEditStep }) => {
  const groups = [
    { title: "Identity", step: "Identity", fields: getIdentityFields(isNaturalClient) },
    { title: "Contact", step: "Contact", fields: getContactFields(isNaturalClient) },
    { title: "Address", step: "Address", fields: getAddressFields(isNaturalClient) },
    { title: "Banking", step: "Banking", fields: getBankingFields() },
  ];

  return (
    <div className="d-flex flex-column gap-3">
      {groups.map((g) => (
        <div key={g.title} className="border rounded-3 overflow-hidden">
          {sectionHeader(g.title, () => onEditStep(g.step))}
          <div
            style={{
              padding: "12px 14px",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
              gap: "10px 16px",
            }}
          >
            {g.fields.map((f) => (
              <div key={f.key}>
                {rowLabel(f.label)}
                {rowValue(getEffectiveValue(f, validation.values))}
              </div>
            ))}
          </div>
        </div>
      ))}

      {isNaturalClient && (
        <div className="border rounded-3 overflow-hidden">
          {sectionHeader("Linked client", () => onEditStep("Linked"))}
          <div
            style={{
              padding: "12px 14px",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
              gap: "10px 16px",
            }}
          >
            {validation.values.add_second_client ? (
              <>
                <div>
                  {rowLabel("Name")}
                  {rowValue(
                    [validation.values.additional_contact2_name, validation.values.additional_contact2_surname]
                      .filter(Boolean)
                      .join(" ")
                  )}
                </div>
                <div>
                  {rowLabel("Social Security Number")}
                  {rowValue(validation.values.additional_contact2_ssn)}
                </div>
                <div>
                  {rowLabel("Mobile Phone")}
                  {rowValue(validation.values.additional_contact2_mobile)}
                </div>
                <div>
                  {rowLabel("Email")}
                  {rowValue(validation.values.additional_contact2_email)}
                </div>
              </>
            ) : (
              <div>
                {rowLabel("Secondary client")}
                {rowValue(null)}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

ReviewStep.propTypes = {
  validation: PropTypes.object.isRequired,
  isNaturalClient: PropTypes.bool.isRequired,
  onEditStep: PropTypes.func.isRequired,
};

export default ReviewStep;
